export default "__VITE_ASSET__7wG1ToT2__"